import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GygStoresList } from 'src/types/apps/gygStoresListTypes'
import { Redux } from 'src/store'

type GygStoresListStateType = {
  gygStores: GygStoresList[]
  gygStore: GygStoresList | undefined
  storePending: boolean
  getStoresPending: boolean
  updateStoresPending: boolean
  errors: any // todo
}

interface GetStoresListResponse {
  data: GygStoresList[]
}

interface StoreResponse {
  data: GygStoresList
}

interface StoreUpdateError {
  error: string
  errors: any[]
  statusCode: number
}

interface UserUpdateThunkPayload {
  id: string
  data: GygStoresList
}

const initialState: GygStoresListStateType = {
  gygStores: [],
  gygStore: undefined,
  errors: {},
  storePending: false,
  getStoresPending: false,
  updateStoresPending: false
}

export const getStoresListed = createAsyncThunk<GetStoresListResponse, void, Redux>(
  'gygStoresList/getStores',
  async (_, { extra }) => {
    const response = await extra.httpClient(`stores?take=0&skip=0`)

    return response.data
  }
)

export const getStoreData = createAsyncThunk<StoreResponse, string, Redux>(
  'gygStoresList/gygStore',
  async (storeId: string, { extra }) => {
    const response = await extra.httpClient(`stores/${storeId}`)

    return response.data
  }
)

export const updateStore = createAsyncThunk<StoreResponse, UserUpdateThunkPayload, Redux>(
  'gygStoresList/updateStore',
  async ({ id, data }, { extra, rejectWithValue }) => {
    try {
      const response = await extra.httpClient(`stores/${id}`, { method: 'PATCH', data })

      return response.data
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data)
      }
    }
  }
)

export const gygStoresList = createSlice({
  name: 'gygStoresList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // All Stores get
      .addCase(getStoresListed.fulfilled, (state, action) => {
        state.gygStores = action.payload.data
        state.getStoresPending = false
      })
      .addCase(getStoresListed.pending, state => {
        state.getStoresPending = true
      })
      .addCase(getStoresListed.rejected, state => {
        state.getStoresPending = false
      })

      // Single Store
      .addCase(getStoreData.fulfilled, (state, action) => {
        state.gygStore = action.payload.data
        state.storePending = false
      })
      .addCase(getStoreData.pending, state => {
        state.storePending = true
      })
      .addCase(getStoreData.rejected, state => {
        state.storePending = false
      })

      // User Store
      .addCase(updateStore.fulfilled, (state, action) => {
        state.updateStoresPending = false
        state.gygStore = (action.payload as StoreResponse).data
        state.errors = {}
      })
      .addCase(updateStore.pending, state => {
        state.updateStoresPending = true
      })
      .addCase(updateStore.rejected, (state, action) => {
        state.errors = (action.payload as StoreUpdateError).errors
        state.updateStoresPending = false
      })
  }
})

export default gygStoresList.reducer
